module.exports = __webpack_public_path__ + "img/esc_4_act_3.3fb72b0b.png";